import { Record } from 'immutable';

const RAv2CicRecord = Record({
  sessionId: undefined,
  levelNumber: undefined,
  unitNumber: undefined,
  lessonNumber: undefined,
  storyTitle: undefined,
  vocabulary: undefined,
  lessonFocus: undefined,
});

class RAv2Cic extends RAv2CicRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'sessionId':
    case 'levelNumber':
    case 'unitNumber':
    case 'lessonNumber':
      return [key, Number(val)];
    default:
      return [key, val];
  }
};

RAv2Cic.create = (data) =>
  new RAv2Cic(data).mapEntries(reviver);

export default RAv2Cic;


// WEBPACK FOOTER //
// ./data/RAv2Cic/model.js